// extracted by mini-css-extract-plugin
module.exports = {"addTags":"AddTags_style_addTags__193BZ","button":"AddTags_style_button__3C7L9","alert":"AddTags_style_alert__14_nZ"};